/* istanbul ignore file */
import { IS_DEVELOPMENT, IS_TEST } from './environment.constants';

export const LANGUAGES_ISO_CODES =
  IS_DEVELOPMENT || IS_TEST ? ['en-US'] : ['en-US', 'fr-FR', 'de-DE', 'es-ES', 'it-IT', 'nb-NO'];
